import api from '@/api/api.js'
import config_api from '@/api/config/_api_config'

export default {
    personnelImportAvailability() { return config_api().get('/users/imports/availability').then(response => response.data) },
    previewPersonnelImport(data) { return config_api().post('/users/imports/preview', data, { headers: { 'Content-Type': 'multipart/form-data' } }).then(response => response.data) },
    revisePersonnelImport(id, data) { return config_api().put('/users/imports/'+id+'/preview', data).then(response => response.data) },
    commitPersonnelImport(id, data, key) { return config_api().post('/users/imports/'+id+'/commit', data, { headers: { 'Idempotency-Key': key } }).then(response => response.data) },
    personnelImportReport(id) { return config_api().get('/users/imports/'+id).then(response => response.data) },
    getListeAccessToPrestation(data) {
        const promise = api().post('/accessibilites/users/type_prestation', data)
        return promise.then((response) => response.data)
    },

    saveConsultationAccessibilite(data) {
        const promise = api().post('/accessibilites/users/access/store', data)
        return promise.then((response) => response.data)
    },

    getAccessCheckerToTypePrestation(data) {
        const promise = api().get('/accessibilites/access/user_id/'+data.auth_id+'/data_type/'+data.data_type)
        return promise.then((response) => response.data)
    },

    getListeRoles() {
        const promise = config_api().get('/roles')
        return promise.then((response) => response.data)
    },

    saveUser(data) {
        const promise = config_api().post('/users/store', data)
        return promise.then((response) => response.data)
    },

    // Aperçu de l'adresse de connexion et du mot de passe initial avant la création d'un compte.
    proposerIdentifiant(data) {
        const promise = config_api().post('/users/identifiant-propose', data)
        return promise.then((response) => response.data)
    },

    deleteUser(data) {
        const promise = config_api().post('/users/delete', data)
        return promise.then((response) => response.data)
    },

    updateUserProfil(data) {
        const promise = config_api().post('/users/update', data)
        return promise.then((response) => response.data)
    },

    updateUserPassword(data) {
        const promise = config_api().post('/users/update/password', data)
        return promise.then((response) => response.data)
    },

    getRolePersonnels() {
        const promise = config_api().get('/users/minimalist')
        return promise.then((response) => response.data)
    },

    // Équipe et accès (administrateur) : la liste porte l'email, jamais les codes de réinitialisation.
    getPersonnels() {
        const promise = config_api().get('/users/personnels')
        return promise.then((response) => response.data)
    },

    getResetPwdCode(user_id) {
        const promise = config_api().get('/users/' + user_id + '/reset-code')
        return promise.then((response) => response.data)
    },

    setResetPwdCode(data) {
        const promise = config_api().post('/users/set-reset-password-code', data)
        return promise.then((response) => response.data)
    },

    changePassword(data) {
        const promise = config_api().post('/users/set-new-password', data)
        return promise.then((response) => response.data)
    },
}
